import { createRouter, createWebHistory } from 'vue-router';

import Login from '@/feature/login/Login';
import Message from '@/feature/login/Message';
import SsoRedirect from '@/feature/login/SsoRedirect';
import SuborganisationLogin from '@/feature/suborganisationLogin/SuborganisationLogin';
import PortalMenu from '@/feature/menu/Menu';
import AccessPoints from '@/feature/accessPoints/AccessPoints';
import AuthorisationResult from '@/feature/accessPoints/AuthorisationResult';
import AccessPointRoutes from '@/feature/inbound/accessPointRoutes/AccessPointRoutes';
import AssignNumbers from '@/feature/inbound/assignNumbers/AssignNumbers';
import AccessPointGroups from '@/feature/inbound/accessPointGroups/AccessPointGroups';
import OriginationGroups from '@/feature/inbound/originationGroups/OriginationGroups';
import RoutePlans from '@/feature/inbound/routePlans/RoutePlans';
import RoutingSchedules from '@/feature/inbound/routingSchedules/RoutingSchedules';
import SipTrunks from '@/feature/inbound/sipTrunks/SipTrunks';
import Campaigns from '@/feature/outbound/campaigns/Campaigns';
import EditCampaign from '@/feature/outbound/campaigns/EditCampaign';
import PacingProfiles from '@/feature/outbound/pacingProfiles/PacingProfiles';
import RetryProfiles from '@/feature/outbound/retryProfiles/RetryProfiles';
import GlobalVariables from '@/feature/serviceConfiguration/GlobalVariables';
import FlowObjects from '@/feature/serviceConfiguration/FlowObjects';
import DeliveryPoints from '@/feature/serviceConfiguration/deliveryPoints/DeliveryPoints';
import DeliveryPointGroups from '@/feature/serviceConfiguration/deliveryPoints/DeliveryPointGroups';
import MediaLists from '@/feature/mediaLists/MediaLists';
import LinkDefinitions from '@/feature/linkDefinitions/LinkDefinitions';
import AutoAttendants from '@/feature/profiles/autoAttendants/AutoAttendants';
import PercentageSplits from '@/feature/profiles/percentageSplits/PercentageSplits';
import VoicemailProfiles from '@/feature/voicemailProfiles/VoicemailProfiles';
import TransmitNotifications from '@/feature/profiles/transmitNotifications/TransmitNotifications';
import TransmitTemplates from '@/feature/profiles/transmitNotifications/TransmitTemplates';
import FTPProfiles from '@/feature/profiles/ftp/FTPProfiles';
import RecordingRetention from '@/feature/recordingRetention/RecordingRetention';
import TrustpilotAccounts from '@/feature/social/trustpilotAccounts/TrustpilotAccounts';
import ViberAccounts from '@/feature/social/viberAccounts/ViberAccounts';
import FacebookAccounts from '@/feature/facebookAccounts/FacebookAccounts';
import LineAccounts from '@/feature/social/lineAccounts/LineAccounts';
import ChatAPIAccounts from '@/feature/chatApiAccounts/ChatAPIAccounts';
import DialCLIProfiles from '@/feature/outbound/dialCLIProfiles/DialCLIProfiles';
import DialTimesProfiles from '@/feature/outbound/dialTimesProfiles/DialTimesProfiles';
import BillingPage from '@/feature/reporting/BillingPage';
import AuditLog from '@/feature/reporting/auditLog/AuditLog';
import UserProfiles from '@/feature/admin/userProfiles/UserProfiles';
import UserTwoFA from '@/feature/admin/2fa/UserTwoFARoutes';
import PasswordConfiguration from '@/feature/admin/PasswordConfiguration';
import Sites from '@/feature/admin/sites/Sites';
import UserGroups from '@/feature/userGroups/UserGroups';
import UserViews from '@/feature/admin/UserViews';
import LicenceTemplates from '@/feature/licenceAdmin/licenceTemplates/LicenceTemplates';
import LicenceSummary from '@/feature/licenceAdmin/licenceSummary/LicenceSummary';
import UserLicences from '@/feature/licenceAdmin/userLicences/UserLicences';
import IdentityProviders from '@/feature/admin/identityProviders/IdentityProviders';
import Announcements from '@/feature/announcements/Announcements';
import CustomPage from '@/feature/customPage/CustomPage';
import SummaryTemplate from '@/feature/summaryTemplates/SummaryTemplates';
import WhatsAppAccounts from '@/feature/social/whatsAppAccounts/WhatsAppAccounts';
import PresentationCLIs from '@/feature/admin/presentationCLIs/PresentationCLIs';

export default createRouter({
    // eslint-disable-next-line no-undef
    history: createWebHistory(__webpack_public_path__),
    routes: [
        {
            path: '/accesspoints',
            component: AccessPoints,
        },
        {
            path: '/accesspointroutes',
            component: AccessPointRoutes,
        },
        {
            path: '/assignnumbers',
            component: AssignNumbers,
        },
        {
            path: '/accesspointgroups',
            component: AccessPointGroups,
        },
        {
            path: '/originationgroups',
            component: OriginationGroups,
        },
        {
            path: '/routeplans',
            component: RoutePlans,
        },
        {
            path: '/schedules',
            component: RoutingSchedules,
        },
        {
            path: '/siptrunks',
            component: SipTrunks,
        },
        {
            path: '/emailauthorise',
            component: AuthorisationResult,
        },
        {
            path: '/sso/identityproviders',
            component: IdentityProviders,
        },
        {
            path: '/autoattendants',
            component: AutoAttendants,
        },
        {
            path: '/percentagesplits',
            component: PercentageSplits,
        },
        {
            path: '/voicemailprofiles',
            component: VoicemailProfiles,
        },
        {
            path: '/campaigns',
            component: Campaigns,
        },
        {
            path: '/campaigns/decommissioning',
            component: Campaigns,
            props: () => ({ decommissioning: true }),
        },
        {
            path: '/campaign/:id',
            component: EditCampaign,
            props: (route) => ({
                scriptId: parseInt(route.params.id),
            }),
        },
        {
            path: '/globalvariables',
            component: GlobalVariables,
        },
        {
            path: '/flowobjects',
            component: FlowObjects,
        },
        {
            path: '/deliverypoints',
            component: DeliveryPoints,
        },
        {
            path: '/deliverypointgroups',
            component: DeliveryPointGroups,
        },
        {
            path: '/medialists',
            component: MediaLists,
        },
        {
            path: '/organisationmedialists',
            component: MediaLists,
            props: {
                orgLists: true,
            },
        },
        {
            path: '/transmit/notifications',
            component: TransmitNotifications,
        },
        {
            path: '/transmit/templates',
            component: TransmitTemplates,
        },
        {
            path: '/ftpprofiles',
            component: FTPProfiles,
        },
        {
            path: '/recordingretention',
            component: RecordingRetention,
        },
        {
            path: '/trustpilot/accounts',
            component: TrustpilotAccounts,
        },
        {
            path: '/trustpilot/authorise',
            component: TrustpilotAccounts,
            props: {
                authorise: true,
            },
        },
        {
            path: '/viber/accounts',
            component: ViberAccounts,
        },
        {
            path: '/line/accounts',
            component: LineAccounts,
        },
        {
            path: '/facebook/accounts',
            component: FacebookAccounts,
        },
        {
            path: '/facebook/authorise',
            component: FacebookAccounts,
            props: {
                authorise: true,
            },
        },
        {
            path: '/whatsapp/accounts',
            component: WhatsAppAccounts,
        },
        {
            path: '/whatsapp/authorise',
            component: WhatsAppAccounts,
            props: {
                authorise: true,
            },
        },
        {
            path: '/dialtimesprofiles',
            component: DialTimesProfiles,
        },
        {
            path: '/dialcliprofiles',
            component: DialCLIProfiles,
        },
        {
            path: '/chargerecords',
            component: BillingPage,
            props: () => ({
                action: 'chargerecords',
            }),
        },
        {
            path: '/billingreports',
            component: BillingPage,
            props: () => ({
                action: 'billingreports',
            }),
        },
        {
            path: '/reporting/auditlog',
            component: AuditLog,
        },
        {
            path: '/userprofiles',
            component: UserProfiles,
        },
        {
            path: '/user2fa',
            component: UserTwoFA,
        },
        {
            path: '/passwordexpiry',
            component: PasswordConfiguration,
        },
        {
            path: '/sites',
            component: Sites,
        },
        {
            path: '/usergroups',
            component: UserGroups,
        },
        {
            path: '/reportsettings',
            component: BillingPage,
            props: () => ({
                action: 'reportsettings',
            }),
        },
        {
            path: '/userviews',
            component: UserViews,
        },
        {
            path: '/licencetemplates',
            component: LicenceTemplates,
        },
        {
            path: '/licencesummary',
            component: LicenceSummary,
        },
        {
            path: '/userlicences',
            component: UserLicences,
        },
        {
            path: '/settings/announcements',
            component: Announcements,
        },
        {
            path: '/presentationclis',
            component: PresentationCLIs,
        },
        {
            path: '/pacingprofiles',
            component: PacingProfiles,
        },
        {
            path: '/retryprofiles',
            component: RetryProfiles,
        },
        {
            path: '/chatapi/accounts',
            component: ChatAPIAccounts,
        },
        {
            path: '/login',
            component: Login,
        },
        {
            path: '/login/tree',
            component: SuborganisationLogin,
        },
        {
            path: '/login/:orgName/:auth',
            name: 'ssologin',
            component: SsoRedirect,
            props: true,
        },
        {
            path: '/message/:code',
            component: Message,
            props: (route) => ({
                code: parseInt(route.params.code),
            }),
        },
        {
            path: '/menu',
            component: PortalMenu,
        },
        {
            path: '/linkdefinitions',
            component: LinkDefinitions,
        },
        {
            path: '/custom',
            component: CustomPage,
        },
        {
            path: '/summarisation/templates',
            component: SummaryTemplate,
        },
    ],
});
